import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CoberturaCatalogo } from '../../model/catalogo.model';
import { CaCheckboxComponent } from '@global-front-components/ui/checkbox';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { Cobertura } from '../../model/poliza.model';
@Component({
	selector: 'app-coberturas',
	standalone: true,
	imports: [
		CommonModule,
		ReactiveFormsModule,
		CaCheckboxComponent],
	templateUrl: './coberturas.component.html',
	styleUrls: ['./coberturas.component.scss']
})
export class CoberturasComponent implements OnInit {
	@Input() coberturasCatalogo: CoberturaCatalogo[];
	@Input() coberturasPoliza: Cobertura[] = [];
	@Input() form: FormGroup;

	constructor(private fb: FormBuilder) { }

	ngOnInit(): void {
		if (!this.form){
			this.form = this.fb.group({});
		}
		this.buildForm();
	}

	buildForm() {
		if (!this.coberturasCatalogo) {
			return;
		}
		this.coberturasCatalogo.forEach((cob) => {
			const controlName = `cob_${cob.idCobertura}`;
			if (cob.obligatoria) {
				this.form.addControl(controlName,this.fb.control({ value: 1, disabled: true }, [Validators.required]));
			} else {
				const coberturaPoliza = this.coberturasPoliza.find(c => c.idCobertura === cob.idCobertura);
				const valor = coberturaPoliza ? 1 : (cob.defecto ? 1 : 0);
				this.form.addControl(controlName, valor);
			}
		});

	}
}
